/**
 * Shared resolver for a user's display color.
 *
 * Every user/artist badge in the app should derive its color from this helper
 * so users without a custom color look identical on every surface.
 * The fallback matches the schema default for users.colorCode.
 */
export const DEFAULT_USER_COLOR = '#6b7280';

export function getUserColor(colorCode?: string | null): string {
  return colorCode || DEFAULT_USER_COLOR;
}
